import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Slide,
  Typography,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import classes from "./CookieConsent.module.scss";

const gdprCookieValue = (): string =>
  document.cookie.replace(
    /(?:(?:^|.*;\s*)GDPR-SuralinkAppCookieUseVerified\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  );

let to: any;
const CookieConsent: React.FC = () => {
  const [open, setOpen] = useState<boolean>(() => false);
  const theme: any = useTheme();

  useEffect(() => {
    // declare internal GDPR cookie verify funtion
    if (typeof window.__verifyGDPRCookie !== "function") {
      window.__verifyGDPRCookie = () => {
        if (gdprCookieValue() === "true")
          return console.log(
            "Suralink Application cookie use has been verified."
          );
        else
          return console.log(
            "You must accept the Suralink Application cookie use agreement in order to have the best experience."
          );
      };
    }
    // declare interal GDPR cookie clearing function
    if (typeof window.__clearGDPRCookie !== "function") {
      window.__clearGDPRCookie = () => {
        document.cookie = `GDPR-SuralinkAppCookieUseVerified=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.host
          .split(".")
          .splice(1)
          .join(".")};`;
        return console.log(
          "Suralink Application cookie use verification has been cleared."
        );
      };
    }

    // if already accepted, return
    if (gdprCookieValue() === "true") {
      return;
    }

    to = setTimeout(() => setOpen(true), 1200);
    return () => {
      clearTimeout(to);
    };
  }, []);

  const handleAccept = () => {
    if (gdprCookieValue() !== "true") {
      document.cookie = `GDPR-SuralinkAppCookieUseVerified=true;expires=Thu, 31 Dec 9999 00:00:00 UTC;path=/;domain=${window.location.host
        .split(".")
        .splice(1)
        .join(".")};`;
      console.log("Suralink Application cookie use has been confirmed.");
    }

    setOpen(false);
  };

  return (
    <Slide direction="up" in={open} style={{ position: "fixed" }}>
      <Card className={classes.alertCard} elevation={8}>
        <CardContent className={classes.content}>
          <Typography variant="h6">We use cookies</Typography>
          <Typography variant="body1" className={classes.textRegular}>
            This application uses cookies to ensure the best possible
            experience.
          </Typography>
          <br />
          <Typography variant="body1" className={classes.textRegular}>
            To learn more, view our{" "}
            <a
              style={{
                color: theme.palette.primary[500],
                textDecoration: "none",
              }}
              href="https://www.suralink.com/cookie-policy/"
              target="blank"
            >
              Cookie Policy
            </a>
            .
          </Typography>
        </CardContent>
        <CardActions className={classes.buttonPositioner}>
          <Button
            variant="contained"
            color="primary"
            style={{
              width: "94px",
              backgroundColor: theme.palette.primary[700],
              color: "#ffffff",
              textTransform: "none",
              boxShadow: "none",
            }}
            onClick={handleAccept}
          >
            Got It
          </Button>
        </CardActions>
      </Card>
    </Slide>
  );
};

export default CookieConsent;
